/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-03-02 09:37:28
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2022-06-12 15:03:08
 * @FilePath: \baishu_react_ui\src\components\BsyAlertHandover\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react'
import ReactDOM from 'react-dom'
import AlertList from './Staticize'

const BsyAlertHandover = props =>
    new Promise((fulfill) => { // 此处参数需用圆括号，否则 eslint 报错
        let holder
        if(document.getElementsByClassName("BsyAlertHandover").length>0){
            document.getElementsByClassName("BsyAlertHandover")[0].removeChild(document.getElementsByClassName("BsyAlertHandover")[0].firstChild);
            holder = document.getElementsByClassName("BsyAlertHandover")[0]
        }else{
            holder = document.createElement('div');
            holder.style.zIndex = window.FX.STATIC.zIndex++
            holder.classList.add("BsyAlertHandover");
            document.body.appendChild(holder)
        }

        let holderTo = document.createElement('div');
        holderTo.classList.add("alertHandoverContent");
        setTimeout(()=>{
            holder.classList.add("fadein");
        },30)
        holder.onclick = (event) =>{
            event.stopPropagation()
        }
        holder.appendChild(holderTo)

        // let timer = setTimeout(()=>{
        //     holder.removeChild(holderTo)
        //     ReactDOM.unmountComponentAtNode(holderTo)
        //     if(document.getElementsByClassName("alertImgCodeContent").length<=0){
        //         document.body.removeChild(holder)
        //         ReactDOM.unmountComponentAtNode(holder)
        //     }
        //     clearInterval(timer)
        // },3000)

        if(document.getElementsByClassName("alertHandoverContent").length>1){
            holder.removeChild(holderTo)
            ReactDOM.unmountComponentAtNode(holderTo)
            // clearInterval(timer)
        }
        const newProps={...props,target:holderTo}

        ReactDOM.render(
            <AlertList
                {...newProps}
            />,
            holderTo
        )
    }).catch(res => {
        console.error('BsyAlertHandover',res);
    })


export default BsyAlertHandover